<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('Checkout') }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">
                                    <li class="breadcrumb-item active" aria-current="page">{{ $t('Checkout') }}</li>
                                    <li class="breadcrumb-item">
                                        <router-link :to="{ name: 'home', params: { lang: $i18n.locale } }">
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- Checkout section Start -->
        <section class="checkout-section-2 section-b-space">
            <div class="container-fluid-lg">
                <form @submit.prevent="create" v-if="cartItems.length > 0">
                    <div class="row g-sm-4 g-3">
                        <div class="col-lg-8">
                            <div class="left-sidebar-checkout">
                                <div class="checkout-detail-box">
                                    <ul>

<!--                                        <li>-->
<!--                                            <div class="checkout-icon d-flex justify-content-center">-->
<!--                                                <i class="fa-regular fa-address-card d-flex align-items-center"></i>-->
<!--                                            </div>-->
<!--                                            <div class="checkout-box">-->
<!--                                                <div class="checkout-title">-->
<!--                                                    <h4>{{ $t('Delivery Address') }}</h4>-->
<!--                                                </div>-->

<!--                                                <div v-if="addresses?.data?.length > 0">-->
<!--                                                    <div class="checkout-detail" >-->
<!--                                                        <div class="row g-4">-->

<!--                                                            <div class="col-xxl-6 col-lg-12 col-md-6"-->
<!--                                                                 v-for="address in addresses?.data" :key="address.id" >-->
<!--                                                                <div class="delivery-address-box">-->
<!--                                                                    <div>-->
<!--                                                                        <div class="form-check">-->
<!--                                                                            <input class="form-check-input" type="radio" name="jack"-->
<!--                                                                                   :id="'flexRadioDefault' + address.id" v-model="item.address_id" :value="address.id">-->
<!--                                                                        </div>-->
<!--                                                                        <div class="label">-->
<!--                                                                            <label :for="'flexRadioDefault' + address.id">{{ address?.name }}</label>-->
<!--                                                                        </div>-->

<!--                                                                        <ul class="delivery-address-detail">-->
<!--                                                                            <li>-->
<!--                                                                                <h4 class="fw-500">-->
<!--                                                                                    <label :for="'flexRadioDefault' + address.id">{{ address?.address }}</label>-->
<!--                                                                                </h4>-->
<!--                                                                            </li>-->

<!--                                                                            <li>-->
<!--                                                                                <h6 class="text-content">-->
<!--                                                                                    <span class="text-title">{{ $t('Country') }} :</span>-->
<!--                                                                                    {{ address?.country?.name }}-->
<!--                                                                                </h6>-->
<!--                                                                            </li>-->

<!--                                                                            <li>-->
<!--                                                                                <h6 class="text-content mb-0">-->
<!--                                                                                    <span class="text-title">{{ $t('City') }} :</span>-->
<!--                                                                                    {{ address?.city?.name }}-->
<!--                                                                                </h6>-->
<!--                                                                            </li>-->
<!--                                                                            &lt;!&ndash;                                                                    <li>&ndash;&gt;-->
<!--                                                                            &lt;!&ndash;                                                                        <p class="text-content">&ndash;&gt;-->
<!--                                                                            &lt;!&ndash;                                                                            <span class="text-title">{{ $t('Address')}} :</span>&ndash;&gt;-->
<!--                                                                            &lt;!&ndash;                                                                            {{ address?.address }}&ndash;&gt;-->
<!--                                                                            &lt;!&ndash;                                                                        </p>&ndash;&gt;-->
<!--                                                                            &lt;!&ndash;                                                                    </li>&ndash;&gt;-->


<!--                                                                            <li>-->
<!--                                                                                <h6 class="text-content mb-0">-->
<!--                                                                                    <span class="text-title">{{ $t('Postal code') }} :</span>-->
<!--                                                                                    {{ address?.postal_code }}-->
<!--                                                                                </h6>-->
<!--                                                                            </li>-->

<!--                                                                            <li>-->
<!--                                                                                <h6 class="text-content mb-0">-->
<!--                                                                                    <span class="text-title">{{ $t('Phone') }} :</span>-->
<!--                                                                                    {{ address?.phone }}-->
<!--                                                                                </h6>-->
<!--                                                                            </li>-->
<!--                                                                        </ul>-->

<!--                                                                    </div>-->

<!--                                                                </div>-->
<!--                                                            </div>-->

<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                    <div class="text-danger pt-3" v-if="isInvalid('address_id')">-->
<!--                                                        {{  isInvalid('address_id') }}-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                                <div class="p-3" v-else>-->

<!--                                                    <a class="btn theme-bg-color text-white btn-sm fw-bold mt-lg-0 mt-3"-->
<!--                                                       data-bs-toggle="modal" data-bs-target="#add-address">-->
<!--                                                        <i data-feather="plus" class="me-2"></i>-->
<!--                                                        {{ $t('Add New Address') }}-->
<!--                                                    </a>-->

<!--                                                </div>-->

<!--                                            </div>-->
<!--                                        </li>-->

                                        <li>
                                            <div class="checkout-icon d-flex justify-content-center">
                                                <i class="fa-regular fa-address-card d-flex align-items-center"></i>
                                            </div>
                                            <div class="checkout-box">
                                                <div class="checkout-title">
                                                    <h4>مستلم الهدية</h4>
                                                </div>


                                                <div class="col-12 mb-3">
                                                    <div class="form-floating theme-form-floating log-in-form">
                                                        <input type="text" class="form-control" id="name"
                                                               :placeholder="$t('Name')" v-model="item.address.name"  :class="{ 'is-invalid' : isInvalid('name')}" required>
<!--                                                        <div class="invalid-feedback" v-if="isInvalid('name')">-->
<!--                                                            {{  isInvalid('name') }}-->
<!--                                                        </div>-->
                                                        <label for="name">{{ $t('Name') }}</label>
                                                    </div>
                                                </div>

                                                <div class="col-12 mb-3">
                                                    <div class="form-floating theme-form-floating log-in-form">
                                                        <input type="text" class="form-control pe-1" id="checkout-phone" placeholder="5×××××"
                                                               aria-label="phone" aria-describedby="phone" v-model="item.address.phone" dir="ltr">

                                                        <label for="checkout-phone">{{ $t('Phone number') }}</label>
                                                    </div>
                                                </div>

                                                <div class="form-floating mb-4 theme-form-floating">

                                                    <select class="form-control" id="city">
                                                        <option >الرياض</option>
                                                    </select>

                                                    <label for="country">{{ $t('City') }}</label>
                                                </div>

                                            </div>
                                        </li>

                                        <li>
                                            <div class="checkout-icon d-flex justify-content-center">
                                                <i class="fa-solid fa-gifts d-flex align-items-center"></i>
                                            </div>
                                            <div class="checkout-box">
                                                <div class="checkout-title">
                                                    <h4>{{ $t('Like to choose gift card') }}</h4>
                                                </div>

                                                <div class="row g-sm-4 g-3 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 product-list-section"
                                                     v-if="cartItems?.length > 0">

                                                    <div v-for="wrapper in wrappers?.data" :key="wrapper.id">
                                                        <div class="product-box-3 h-100 wow fadeInUp bg-white rounded">
                                                            <div class="product-header">
                                                                <div class="product-image">
                                                                    <img :src="wrapper.image ?? '/theme/assets/images/more/gift-card.png'"
                                                                         class="img-fluid blur-up lazyload" alt="">
                                                                </div>
                                                            </div>
                                                            <div class="product-footer">
                                                                <div class="product-detail">
                                                                    <div class=" overflow-hidden"
                                                                         v-if="wrapper?.occasions?.length > 0">
                                                                        <div class=" d-flex justify-content-start overflow-x-auto"
                                                                             v-if="wrapper?.occasions?.length > 0">
                                                                            <div class=" p-1"
                                                                                 v-for="occasion in wrapper?.occasions">
                                                                                <img :src="occasion?.icon"
                                                                                     :alt="occasion?.name"
                                                                                     class=" border p-1 rounded-circle"
                                                                                     data-bs-toggle="tooltip"
                                                                                     data-bs-placement="top"
                                                                                     :title="occasion?.name" height="25"
                                                                                     width="25">
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <h5 class="name"> {{ wrapper?.name }} </h5>
                                                                    <p class="text-content mt-1 mb-2 product-content">
                                                                        {{ wrapper?.description }}
                                                                    </p>
                                                                    <h5 class="d-flex justify-content-end">
                                                                        <h5 class="price">
                                                                            <span class="theme-color">{{ wrapper?.price_tax }}
                                                                                {{ $t('SAR') }}</span>
                                                                        </h5>
                                                                    </h5>

                                                                    <label :for="'flexRadioWrapper' + wrapper.id"
                                                                           class="d-flex bg-light rounded-3 p-2 justify-content-center text-bg-light mt-2">

                                                                        <span class="form-check form-switch m-0">
                                                                            <input class="form-check-input" type="radio"
                                                                                   name="select_wrapper"
                                                                                   :id="'flexRadioWrapper' + wrapper.id"
                                                                                   @change="selectWrapper(wrapper)">

                                                                            <span class="form-check-label pt-1">
                                                                                {{ $t('Select') }}
                                                                            </span>

                                                                        </span>
                                                                    </label>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="w-100">
                                                        <Bootstrap5Pagination class="m-2" :data="wrappers" :limit="2"
                                                                              :show-disabled="false" :size="'default'" :align="'center'"
                                                                              @pagination-change-page="getWrappers" />
                                                    </div>

                                                </div>


                                                <div class="d-flex justify-content-end" v-if="wrapper_selected ">
                                                    <button class="btn btn-sm btn-light " type="button"  @click="deselectWrapper"> {{ $t('Remove gift wrap') }}</button>
                                                </div>

                                            </div>
                                        </li>

                                        <li>
                                            <div class="checkout-icon d-flex justify-content-center">
                                                <i class="fa-regular fa-credit-card d-flex align-items-center"></i>
                                            </div>
                                            <div class="checkout-box">
                                                <div class="checkout-title">
                                                    <h4>{{ $t('The text of the message written on the gift card') }}</h4>
                                                </div>

                                                <div class="checkout-detail">
                                                    <textarea class="form-control" v-model="item.note"
                                                              placeholder="اكتب رسالتك هنا" maxlength="200"></textarea>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="checkout-icon d-flex justify-content-center">
                                                <i class="fa-regular fa-credit-card d-flex align-items-center"></i>
                                            </div>
                                            <div class="checkout-box">
                                                <div class="checkout-title">
                                                    <h4>{{ $t('Payment Option') }}</h4>
                                                </div>

                                                <div class="checkout-detail">
                                                    <div class="accordion accordion-flush custom-accordion"
                                                         id="accordionFlushPayment">
                                                        <div class="accordion-item">
                                                            <div class="accordion-header" id="flush-headingFour">
                                                                <div class="accordion-button collapsed"
                                                                     data-bs-toggle="collapse"
                                                                     data-bs-target="#flush-collapseFour">
                                                                    <div class="custom-form-check form-check mb-0">
                                                                        <label class="form-check-label" for="cash"><input
                                                                            class="form-check-input mt-0" type="radio"
                                                                            name="flexRadioDefault" id="cash" checked>
                                                                            {{ $t('Online payment') }}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div id="flush-collapseFour"
                                                                 class="accordion-collapse collapse show"
                                                                 data-bs-parent="#accordionFlushPayment">
                                                                <div class="accordion-body">
                                                                    <p class="cod-review">
                                                                        <img src="/theme/assets/images/more/telr.png"
                                                                             class="blur-up lazyload mw-100" alt=""
                                                                             style="width: 300px">
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </li>


                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="right-side-summery-box">
                                <div class="summery-box-2">
                                    <div class="summery-header">
                                        <h3>{{ $t('Order Summery') }}</h3>
                                    </div>
                                    <ul class="summery-contain mb-2">

                                        <li v-for="cartItem in cartItems" :key="cartItem.id">
                                            <img :src="cartItem.product.image ?? '/theme/assets/images/more/gift-card.png'"
                                                 class="img-fluid blur-up lazyloaded checkout-image" alt="">
                                            <div class="d-flex flex-column">
                                                <h4> {{ cartItem.product.name }} × <span> {{ cartItem.quantity }}</span></h4>
                                                <span class="text-title" v-if="cartItem.selected_price !== null"> {{
                                                        cartItem.selected_price?.name }}</span>

                                                <div class="text-content" v-for="(attribute, attributeId) in cartItem.product.attributes" :key="attributeId">
                                                    <span class="text-title"> {{ attribute?.data?.name }} : </span>
                                                    <span>{{ getSelectedAttributeValue(attributeId, cartItem) }}</span>
                                                </div>
                                            </div>

                                            <h4 class="price">{{ cartItem.selected_price?.price_tax || cartItem.product.price_tax }} {{
                                                    $t('SAR') }}</h4>

                                        </li>

                                    </ul>


                                    <h3 v-if="wrapper_selected">{{ $t('Wrapper') }}</h3>

                                    <ul class="summery-contain">
                                        <li v-if="wrapper_selected != null">
                                            <img :src="wrapper_selected.image ?? '/theme/assets/images/more/gift-card.png'"
                                                 class="img-fluid blur-up lazyloaded checkout-image" alt="">
                                            <h4>
                                                {{ wrapper_selected.name }}
                                            </h4>
                                            <h4 class="price">{{ wrapper_selected.price_tax }} {{ $t('SAR') }}</h4>
                                        </li>
                                    </ul>

                                    <ul class="summery-total mb-2">
                                        <li>
                                            <h4>{{ $t('Subtotal') }}</h4>
                                            <h4 class="price">

<!--                                                <del v-if="capone.totals != null">-->
                                                    {{ subtotal }} {{ $t('SAR') }}
<!--                                                </del>-->
<!--                                                <template v-else>-->
<!--                                                    {{ subtotal }} {{ $t('SAR') }}-->
<!--                                                </template>-->

                                            </h4>
                                        </li>

                                        <li  v-if="discount > 0">
                                            <h4> {{ $t('Discount') }} </h4>
                                            <h4 class="price">{{ discount }} {{ $t('SAR') }}</h4>
                                        </li>


                                        <li  v-if="discount > 0">
                                            <h4> {{ $t('Subtotal') }} </h4>
                                            <h4 class="price">{{ subtotal - ( discount ?? 0 )  }} {{ $t('SAR') }}</h4>
                                        </li>


<!--                                        <li v-if="capone.totals != null">-->
<!--                                            <h4>{{ $t('Tax') }}</h4>-->
<!--                                            <h4 class="price">{{ capone?.totals?.total_tax }} {{ $t('SAR') }}</h4>-->
<!--                                        </li>-->
<!--                                        <li  v-else>-->
<!--                                            <h4>{{ $t('Tax') }}</h4>-->
<!--                                            <h4 class="price">{{ tax }} {{ $t('SAR') }}</h4>-->
<!--                                        </li>-->
                                        <li>
                                            <h4>{{ $t('Tax') }}</h4>
                                            <h4 class="price">{{ tax }} {{ $t('SAR') }}</h4>
                                        </li>

                                        <li v-if="isFreeShipping == true">
                                            <h4 >{{ $t('Shipping and delivery') }}</h4>
                                            <h4 class="price">

                                                <del>
                                                    {{ main.settings?.shipping_cost }} {{ $t('SAR') }}
                                                </del>
                                                <b class="text-success">
                                                    مجاناً
                                                </b>

                                            </h4>
                                        </li>
                                        <li v-else>
                                            <h4 class="text-left">{{ $t('Shipping and delivery') }}</h4>
                                            <h4 class="price">{{ main.settings?.shipping_cost }} {{ $t('SAR') }}</h4>
                                        </li>


                                        <li>
                                        </li>
                                    </ul>


                                    <form class="ec-cart-coupan-form w-100" name="ec-cart-coupan-form" method="post"
                                          action="#"  @submit.prevent="checkCoupon">
                                        <div class="summery-contain">
                                            <div class="coupon-cart">
                                                <h6 class="text-content mb-2">تطبيق كوبون خصم</h6>
                                                <div class="mb-3 coupon-box input-group">
                                                    <input type="text" class="form-control"
                                                           id="exampleFormControlInput1" placeholder="ضع كوبون الخصم هنا..."
                                                           v-model="item.coupon_code">
                                                    <button class="btn-apply" type="submit">تطبيق</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                    <ul class="summery-total">
<!--                                        <li class="list-total mt-2">-->
<!--                                            <h4>{{ $t('Total') }}</h4>-->
<!--                                            <h4 class="price">{{ total + ( wrapper_selected?.price_tax ?? 0) }} {{ $t('SAR') }}</h4>-->
<!--                                            &lt;!&ndash;                                            <h4 class="price">{{ total }} {{ $t('SAR') }}</h4>&ndash;&gt;-->
<!--                                        </li>-->

<!--                                        <li  class="list-total mt-2" v-if="capone.totals != null">-->
<!--                                            <h4>{{ $t('Total') }}</h4>-->
<!--                                            <h4 class="price">-->
<!--                                                <del>-->
<!--                                                    {{ total }} {{ $t('SAR') }}-->
<!--                                                </del>-->
<!--                                                {{ capone?.totals?.total }} {{ $t('SAR') }}-->
<!--                                            </h4>-->
<!--                                        </li>-->

<!--                                        <li class="ec-checkout-summary-total" v-else>-->
<!--                                            <h4>{{ $t('Total') }}</h4>-->
<!--                                            <h4 class="price">{{ total }} {{ $t('SAR') }}</h4>-->
<!--                                        </li>-->
                                        <li class="ec-checkout-summary-total">
                                            <h4>{{ $t('Total') }}</h4>
                                            <h4 class="price">{{ total }} {{ $t('SAR') }}</h4>
                                        </li>

                                    </ul>

                                </div>

                                <button class="btn theme-bg-color text-white btn-md w-100 mt-4 fw-bold" type="submit">
                                    {{ $t('Place your gift') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="alert alert-danger" v-else>
                    {{ $t('No items in gift box') }}
                </div>
            </div>
        </section>
        <!-- Checkout section End -->

<!--        <create-address @add="addAddress"></create-address>-->


    </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import { Bootstrap5Pagination } from 'laravel-vue-pagination'

import { mapGetters, mapActions } from 'vuex';
import CartButton from "./CartButton.vue";
import CreateAddress from "../address/create.vue";

import Utility from "../../utility";

export default {
    components: {
        CreateAddress,
        CartButton,
        Bootstrap5Pagination
    },
    props: ['main'],
    watch: {
        main: {
            handler: function (val) {
                this.setMainSettings(this.main.settings);
            },
            deep: true,
        },
    },
    data() {
        return {
            wrappers: [],
            addresses: {},
            wrapper_selected: null,
            capone: {},
            item: {
                address : {}
            },
            validationErrors: null,
        }
    },
    created() {
        // this.getAddresses();

        this.getWrappers(1);
    },
    computed: {
        ...mapGetters(['cartItems', 'getSelectedAttributeValue', 'subtotal', 'tax', 'total', 'discount', 'isFreeShipping']),
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart', 'setWrapperSelected', 'removeWrapperSelected','setMainSettings','applyCoupon']), // Map the addToCart and removeFromCart actions
        selectWrapper(wrapper) {
            this.wrapper_selected = wrapper;
            this.setWrapperSelected(wrapper);
        },
        deselectWrapper() {
            this.removeWrapperSelected();

            const radioInput = document.querySelector(`#flexRadioWrapper${this.wrapper_selected?.id}`);
            if (radioInput) {
                radioInput.checked = false;
            }

            this.wrapper_selected = null;
        },
        // addAddress(newItemData) {
        //     this.addresses?.data?.unshift(newItemData);
        // },
        async checkCoupon() {
            const response = await this.applyCoupon(this.item.coupon_code);
            if (response && response.status) {
                this.capone = response.data;
                toast.success(response.message, { timeout: 3000 }, { icon: 'fa-solid fa-circle-check' });
                this.$store.dispatch('setCoupon', response.data);  // Update the store with new coupon data
            } else {
                console.log(response);
                toast.error(this.$t(response.message ?? 'Invalid coupon'), { timeout: 3000 }, { icon: 'fa-solid fa-circle-exclamation' });
            }
        },
        // applyCapone() {
        //     this.capone = {};
        //     const id = toast.info(this.$t('Applying coupon ...'), {icon: 'fa-solid fa-download'});
        //     axios.post('coupons/check', this.item).then(response => {
        //         toast.dismiss(id);
        //         this.capone = response.data;
        //     }, response => {
        //         toast.dismiss(id);
        //     });
        // },
        // getAddresses ( ) {
        //
        //     const id = toast.info(this.$t('Getting content ...'),{ icon: 'fa-solid fa-download' });
        //     axios.get('addresses',  ).then(response => {
        //         toast.dismiss(id);
        //         this.addresses = response.data;
        //     }, response => {
        //         toast.dismiss(id);
        //     });
        //
        // },
        isInvalid(name) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {
            const id = toast.info(this.$t('Adding content...'), { icon: 'fa-solid fa-cloud-arrow-up' });

            const that = this;
            this.validationErrors = null;

            let formData = Utility.convertModelToFormData(this.item);
            // let formData = new FormData();

            // Object.entries(this.item).forEach(([key, value]) => {
            //     formData.append(key, value);
            // });
            console.log( formData );
            console.log(this.wrapper_selected?.id);
            if(this.wrapper_selected) formData.append('wrapper_id', this.wrapper_selected?.id );

            axios.post('orders', formData)
                .then(response => {
                    toast.dismiss(id);
                    toast.success(response.data.message, { timeout: 3000 }, { icon: 'fa-solid fa-circle-check' });

                    this.item = {};

                    window.location.href = '/payment?id=' + response.data.data.id;
                })
                .catch(error => {
                    toast.dismiss(id);
                    if (error.response) {
                        that.validationErrors = error.response.data.errors;
                        toast.error(error.response.data.message, { timeout: 3000 }, { icon: 'fa-solid fa-circle-exclamation' });
                    }
                });
        },

        async getWrappers(page) {
            const id = toast.info(this.$t('Getting content ...'), { icon: 'fa-light fa-filter-list' });
            await axios.get('wrappers', { params: { page: page } }).then(response => {
                toast.dismiss(id);
                this.wrappers = response.data;
            }, response => {
                toast.dismiss(id);
            });
        },
    },
};
</script>
